/**
 * One place to save a file the app produced or fetched (a generated invoice
 * PDF, a customer attachment, a CSV export).
 *
 * Ported from xop-edge-staff with its DESKTOP branch removed. That app ships
 * a Tauri shell and calls a native Save-As dialog; XOP Reseller is web-only —
 * an explicit product decision recorded in this repo's README — so there is no
 * shell to call, and importing `@tauri-apps/api` would pull a dependency that
 * can never run here.
 *
 * Standalone (no imports) so it is safe to use from anywhere, including the
 * ported CRM sub-app.
 */

/** Browser download via a temporary object URL + anchor click. */
function anchorDownload(filename: string, blob: Blob): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename || "download";
  document.body.appendChild(a);
  a.click();
  a.remove();
  // Revoke after the download has had a chance to start.
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

/**
 * Save `blob` under `filename`. `async` — matching the source's signature, so
 * the ported call sites that `await` it compile unchanged — even though the
 * browser path is synchronous.
 */
export async function saveBlob(filename: string, blob: Blob): Promise<void> {
  anchorDownload(filename, blob);
}
